import React from 'react'

function Markets() {
  return (
    <div className='py-[28px]'>Markets</div>
  )
}

export default Markets